/* VNI Framework JS
   Version 1.1.0
*/
(function(){
  function ready(fn){
    if(document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function(){
    var revealItems = document.querySelectorAll(
      ".vni-section-header, .vni-card, .vni-knowledge-box, .vni-timeline__item, .vni-stat-card, .vni-resource-card, .vni-article-card, .vni-doctor-grid, .vni-service-card, .vni-principle-card, .vni-testimonial-card, .vni-condition-card, .vni-final-cta__shell, .vni-faq__item"
    );

    revealItems.forEach(function(item, index){
      item.style.setProperty("--vni-reveal-index", index % 7);
    });

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach(function(item){ item.classList.add("vni-is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add("vni-is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });

    revealItems.forEach(function(item){
      item.classList.add("vni-reveal-item");
      observer.observe(item);
    });

    document.querySelectorAll(".vni-faq__item").forEach(function(detail){
      detail.addEventListener("toggle", function(){
        if(!detail.open) return;
        document.querySelectorAll(".vni-faq__item[open]").forEach(function(other){
          if(other !== detail) other.removeAttribute("open");
        });
      });
    });
  });
})();
